<!--
 * @Description: 
-->
<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.questionCategory"
        placeholder="试题分类"
      >
        <el-option
          v-for="(item, i) in questionCategoryData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.examQuestionType"
        placeholder="试题类型"
      >
        <el-option
          v-for="(item, i) in questionTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.questionTitle"
        placeholder="试题题干/试题主题"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      questionCategoryData: [],
      questionTypeData: [],
    };
  },
  created() {
    this.getSysParamByTypes(["EXAM_QUESTION_CATEGORY", "EXAM_QUESTION_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["EXAM_QUESTION_CATEGORY"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["EXAM_QUESTION_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.questionCategoryData = res.data["EXAM_QUESTION_CATEGORY"];
        this.questionTypeData = res.data["EXAM_QUESTION_TYPE"];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
